// components/Contact.js
import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 这里可以添加实际的表单提交逻辑
    console.log('表单提交:', formData);
    setSubmitted(true);
    // 重置表单
    setFormData({
      name: '',
      phone: '',
      email: '',
      service: '',
      message: ''
    });
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2>联系我们</h2>
        <div className="contact-content">
          <div className="contact-info">
            <h3>获取专业环保服务</h3>
            <p>我们随时准备为您提供专业的环保解决方案，请通过以下方式联系我们：</p>
            
            <div className="contact-item">
              <strong>姓名：</strong>
              <a href="tel:022-12345678">王经理</a>
            </div>
            
            <div className="contact-item">
              <strong>手机：</strong>
              <a href="tel:13516196490">18822744310</a>
            </div>
            
            <div className="contact-item">
              <strong>邮箱：</strong>
              <a href="Mr.Wang_Gx@163.com">Mr.Wang_Gx@163.com</a>
            </div>
            
            <div className="contact-item">
              <strong>地址：</strong>
              天津市武清开发区福源道北侧麒麟商业中心2号楼2单元501室
            </div>
            
            <div className="working-hours">
              <strong>工作时间：</strong>
              周一至周五 8:30-17:30
            </div>
          </div>
          
          <div className="contact-form">
            <h3>在线留言</h3>
            {submitted ? (
              <div className="success-message">
                感谢您的留言！我们会在24小时内与您联系。
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                
                <div className="form-group">
                  <label htmlFor="phone">电话 *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="service">咨询服务</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                  >
                    <option value="">请选择服务类型</option>
                    <option value="环保咨询">企业环保咨询</option>
                    <option value="设备安装">环保设备安装运维</option>
                    <option value="在线监测">污染源在线监测</option>
                    <option value="污水处理">污水处理站运维</option>
                    <option value="软件开发">软件开发</option>
                    <option value="其他">其他</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">留言内容 *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                
                <button type="submit" className="btn btn-primary">
                  提交留言
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;